/* import __COLOCATED_TEMPLATE__ from './edit-verification-method.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { showNextModal, closeModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'edit-verification-method-modal'

class ProjectVerificationMethodModal extends Component {
  @service session;

  @tracked projectToVerify = null;

  get baseClassName() {
    return CLASS_NAME;
  }

  get isSelectDisabled() {
    return !this.projectToVerify;
  }

  @action
  setProjectToVerify(projectdigest) {
    this.projectToVerify = projectdigest;
  }

  @action
  onCancelClicked() {
    closeModal(this);
  }

  @action
  onSelectClicked() {
    showNextModal(this, 'work-samples/verification-method', { projectDigest: this.projectToVerify, isEditing: true });
  }
}

export default ProjectVerificationMethodModal;
